<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<Table :no-data-text="$t('common.noData')" :columns="columns" :data="portListData" style="width: 100%;"></Table>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data () {
            return {
                columns: [
                  {
                    title: this.$t('Bill.CostAllocation.name'),
                    key: "indexName"
                  },
                  {
                    title: this.$t("alarms.common.status"),
                    key: "indexStatusName"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.partitionKey"),
                    key: "partitionKey"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.sortKey"),
                    key: "sortKey"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.readCapacity"),
                    key: "readCapacityUnits"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.writeCapacity"),
                    key: "writeCapacityUnits"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.projectionAttribute"),
                    key: "projection"
                  },
                  {
                    title: this.$t("RAM.ALI.Ack.size"),
                    key: "indexSizeBytes"
                  },
                  {
                    title: this.$t("RAM.AWS.DynamoDB.numberOfEntries"),
                    key: "itemCount"
                  }
                ],
                portListData:this.row.dynamodbGlobalSecondaryIndexList
            }
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/dynamoDB/TableExpand.vue